module.exports = "<p>\r\n  catalogue-departments works!\r\n</p>\r\n"